import {
  HrLine,
  StudentModalHeader,
} from "../commonStyles";
import ReactSpeedometer from "react-d3-speedometer";
import { useTranslation } from "react-i18next"; //translation
export default function EnglishProficiencyModal(props) {
  var levelsGrammar = {
    "Level 1": {
      min: 0,
      max: 49,
      message:
        "The talent has demonstrated basic knowledge of English Grammar and must aim to develop your knowledge to a higher level. He/she can do this through taking English classes, talking to others who speak English well, reading and listening to English language media.",
    },
    "Level 2": {
      min: 50,
      max: 59,
      message:
        "The talent has demonstrated average knowledge of English Grammar and must aim to develop your knowledge to a higher level.He/she can do this through taking English classes, talking to others who speak English well, reading and listening to English language media.",
    },
    "Level 3": {
      min: 60,
      max: 75,
      message:
        "The talent has demonstrated above average knowledge of English.The talent has a good basis to learn more and develop and may choose to challenge oneself to increase his/her knowledge by taking regular English classes, reading English novels, seeking out opportunities to engage in English conversation and regularly following English language media.",
    },
    "Level 4": {
      min: 76,
      max: 90,
      message:
        "The talent has demonstrated good knowledge of English.The talent is well placed to move to a higher level.  He/she must challenge oneself by taking advanced English classes, reading English literature, seeking out opportunities to engage in English conversation and regularly following English language media.",
    },
    "Level 5": {
      min: 91,
      max: 100,
      message:
        "The talent has demonstrated strong knowledge of English.The talent must keep challenging oneself to remain at this advanced level by considering a higher qualification in English, taking advanced English classes, reading a variety of English language texts and literature regularly, seeking out opportunities to engage in English conversation and following English language media.",
    },
  };
  var levelsComprehension = {
    "Level 1": {
      min: 0,
      max: 49,
      message:
        "The talent has demonstrated basic understanding of a text in English and now must aim to develop this understanding to a higher level One can do this by taking regular classes in English and through reading English language news articles and stories, listening to English language podcasts and watching movies.",
    },
    "Level 2": {
      min: 50,
      max: 59,
      message:
        "The talent has demonstrated average understanding of a text in English and now must aim to develop this understanding to a higher level.One can do this through reading and listening to English language media, reading novels in English, and taking English classes.",
    },
    "Level 3": {
      min: 60,
      max: 75,
      message:
        "The talent has demonstrated above average understanding of a text in English.The talent must challenge oneself to increase your understanding by taking regular English classes, reading English literature, seeking out opportunities to engage in English conversation and regularly following English language media.",
    },
    "Level 4": {
      min: 76,
      max: 90,
      message:
        "The talent has demonstrated good understanding of a text in English.The talent must oneself to raise his/her understanding by taking advanced English classes, reading a variety of English texts and literature regularly, seeking out opportunities to engage in English conversation and following English language media.",
    },
    "Level 5": {
      min: 91,
      max: 100,
      message:
        "The talent has demonstrated excellent understanding of a text in English.The talent must keep challenging oneself to remain at this level by considering a higher qualification in English, taking advanced English classes, reading a variety of English texts and literature regularly, seeking out opportunities to engage in English conversation and following English language media. He/she can also consider producing content in English.",
    },
  };
  //translation
  const { t, i18n } = useTranslation();
  const changeLanguageHandler = (lang) => {
    const languageValue = lang;
    i18n.changeLanguage(languageValue);
  };
  // end translation

  return (
    <>
      <StudentModalHeader>{t("English Proficiency")}</StudentModalHeader>
      <HrLine />
      <br />

      {/* <StudentModalChartWrapper>
        <EnglishProficienyChart />
      </StudentModalChartWrapper> */}
      <div className="row mt-5">
        <div className="col-md-5">
          <ReactSpeedometer
            height={180}
            value={
              props?.data?.General?.values?.Comprehension?.points
                ? parseInt(
                    props?.data?.General?.values?.Comprehension?.points
                  ) / 100
                : 0
            }
            segmentColors={[
              "#fa701c",
              "#ffaf00",
              "#fded07",
              "#b1f933",
              "#33ff6c",
            ]}
            needleColor={"#c3348b"}
            maxValue={1}
            customSegmentStops={[0, 0.5, 0.6, 0.75, 0.9, 1.0]}
            valueFormat=".0%"
          />
        </div>
        <div className="col-md-7">
          <h5>{t("Comprehension")}</h5>
          {t(props?.data?.General?.values?.Comprehension?.score)} -
          {typeof props.data === "object" &&
          !Array.isArray(props.data) &&
          props.data !== null
            ? t(
                levelsComprehension[
                  props?.data?.General?.values?.Comprehension?.score
                ]["message"]
              )
            : t("Assessment Not Completed")}
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-md-5">
          <ReactSpeedometer
            height={180}
            value={
              props?.data?.General?.values?.Grammar?.points
                ? parseInt(
                    props?.data?.General?.values?.Grammar?.points
                  ) / 100
                : 0
            }
            segmentColors={[
              "#fa701c",
              "#ffaf00",
              "#fded07",
              "#b1f933",
              "#33ff6c",
            ]}
            needleColor={"#c3348b"}
            maxValue={1}
            customSegmentStops={[0, 0.5, 0.6, 0.75, 0.9, 1.0]}
            valueFormat=".0%"
          />
        </div>
        <div className="col-md-7">
          <h5>{t("Grammar")}</h5>
          {t(props?.data?.General?.values?.Grammar?.score)} -{}
          {typeof props.data === "object" &&
          !Array.isArray(props.data) &&
          props.data !== null
            ? t(
                levelsGrammar[
                  props?.data?.General?.values?.Grammar?.score
                ]["message"]
              )
            : t("Assessment Not Completed")}
        </div>
      </div>
    </>
  );
}
